import { Form, FormInstance, Input, InputNumber, message } from 'antd'
import { useEffect } from 'react'
import LocalizationKeys from '../../../i18n/LocalizationKeys'
import { useAppSelector } from '../../../store/hooks'
import { requiredRule, stringRule } from '../../../helpers/rules'
import i18n from '../../../i18n/setupLocalization'
import TextArea from 'antd/es/input/TextArea'
import { selectSelectedAnswer } from '../../../store/AnswerReducer'
import ButtonsEditor from '../button/ButtonsEditor'
import AttachmentEditor, {
  validateFileList,
} from '../attachment/AttachmentEditor'

interface Props {
  form: FormInstance
}

const Update = ({ form }: Props) => {
  const item = useAppSelector(selectSelectedAnswer())

  useEffect(() => {
    form.setFieldsValue(item)
    if (item?.attachments) {
      form.setFieldValue(
        'file',
        (item?.attachments ?? []).map((value) => ({
          uid: value.id.toString(),
          name: value.name,
          thumbUrl: value.url,
        }))
      )
    }
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={(changed, values) => {
        if (changed.hasOwnProperty('file')) {
          try {
            validateFileList(form, changed.file)
          } catch (error) {
            message.error(error as string)
          }
        }
      }}
    >
      <Form.Item
        name="id"
        required
        rules={[requiredRule()]}
        style={{ display: 'none' }}
      >
        <Input type="hidden" />
      </Form.Item>
      <Form.Item
        name="message"
        rules={[requiredRule(), stringRule()]}
        label={i18n.t(LocalizationKeys.Misc.Form.Message)}
      >
        <TextArea rows={8} />
      </Form.Item>
      <ButtonsEditor />
      <AttachmentEditor
        initialDisplayForm={(item?.attachments ?? []).length > 0}
      />
    </Form>
  )
}

export default Update
